import { RootState } from "../store/store";

export const getCustomerUsersData = (state: RootState) => state.authorizedUsers.clientDetails;